'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _FileControl = require('../../../lib/ui/FileControl');

var _FileControl2 = _interopRequireDefault(_FileControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Import = function () {
  function Import(element, args) {
    _classCallCheck(this, Import);

    this.element = element;
    this.args = args;

    this.render(element);
  }

  _createClass(Import, [{
    key: 'render',
    value: function render(element) {
      var fragment = document.createDocumentFragment();

      this.renderNavigation(fragment);

      var div = document.createElement('div');
      div.className = 'viewport';

      var p = document.createElement('p');
      p.innerHTML = 'Geef hieronder het import bestand op.';

      div.appendChild(p);

      this.renderForm(div);

      fragment.appendChild(div);

      var button = document.createElement('button');
      button.innerHTML = 'Importeer bestand';
      button.onclick = this.onimport;

      fragment.appendChild(button);

      element.appendChild(fragment);
    }
  }, {
    key: 'renderForm',
    value: function renderForm(element) {
      var fieldsetFile = document.createElement('fieldset');
      var legendFile = document.createElement('legend');
      legendFile.innerHTML = 'Importeren';
      fieldsetFile.appendChild(legendFile);

      this.file = new _FileControl2.default(fieldsetFile, { label: 'Import bestand' });

      element.appendChild(fieldsetFile);
    }
  }, {
    key: 'renderNavigation',
    value: function renderNavigation(element) {
      new _NavigationBarControl2.default(element, {
        title: 'Gegevens importeren',
        leftHandButtons: [{
          onclick: function onclick() {
            history.back();
          },
          icon: '\uE00D'
        }]
      });
    }
  }, {
    key: 'onimport',
    value: function onimport() {
      if (this.file.input.files.length === 0) {
        alert('Kies eerst een import bestand.');
        return;
      }

      var reader = new FileReader();
      reader.onload = function () {
        var data = JSON.parse(reader.result);
        var promises = [];

        if (data.people) {
          data.people.forEach(function (item) {
            promises.push(window.PRIM.dataAccess.put(item));
          });
        }

        Promise.all(promises).then(function () {
          alert(promises.length + ' item(s) zijn geimporteerd.');
        }, function () {
          alert('Er is een fout opgetreden. Niet alle ' + promises.length + ' item(s) zijn geimporteerd.');
        });
      };
      reader.onerror = function () {
        alert('Er is een fout opgetreden. Het bestand kon niet worden gebruikt als import bestand.');
      };
      reader.readAsText(this.file.input.files[0]);
    }
  }]);

  return Import;
}();

exports.default = Import;


//////////////////
// WEBPACK FOOTER
// ./js/modules/import/action/Import.js
// module id = 29
// module chunks = 0